import React, {useEffect} from "react";

import styles from "./Content2Page.module.css";

export default function ContentPage() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className={styles.contentContainer}>
      <h1>สรุปเนื้อหา เศรษฐศาสตร์</h1>
      <h2>หน่วยเศรษฐกิจ</h2>
      <p>
        หน่วยเศรษฐกิจ หมายถึงคน กลุ่มคน
        องค์กรที่ดำเนินกิจกรรมทางเศรษฐกิจหรือกิจกรรมที่เกี่ยวข้องกับชีวิตประจำวันของเรา
        ซึ่งมีอยู่ 3 หน่วยคือ หน่วยครัวเรือน หน่วยธุรกิจ และรัฐบาล
        <br></br><br></br>‘หน่วยครัวเรือน’ หมายถึงคนตั้งแต่ 1 คนที่อยู่ในบ้านเดียวกัน
        ตัดสินใจที่จะใช้ทรัพยากรหรือเงินร่วมกัน
        เพื่อให้เกิดประโยชน์สูงสุดและความพึงพอใจสูงสุดกับคนในบ้านของตัวเอง
        <br></br><br></br>‘หน่วยธุรกิจ’ หมายถึงคนตั้งแต่ 1
        คนที่นำปัจจัยการผลิตหรือทรัพยากรมาผลิตเป็นสินค้าและบริการ
        เพื่อขายให้คนอื่น ไม่ว่าจะเป็นครัวเรือน รัฐบาล
        หรือภาคธุรกิจด้วยกันเองก็ได้
        เพื่อสร้างกำไรสูงสุดและตอบสนองต่อความต้องการของผู้คนในสังคม 
        <br></br><br></br>‘รัฐบาล’
        หมายถึง หน่วยงานของรัฐที่ดำเนินกิจกรรมทางเศรษฐกิจเพื่อประชาชนเป็นหลัก
        ทั้ง 3 หน่วยมีความสัมพันธ์ร่วมกันอยู่ตลอดเวลา เป็นวงจรวนเวียนกันไปมา
      </p>
      <p>
        จริง ๆ แล้วเรื่องมันเป็นแบบนี้ เริ่มจากตัวเราก่อนแล้วกัน
        <br></br><br></br>สมมติว่าตื่นมาตอนเช้า เรา (มนุษย์จากหน่วยครัวเรือนคนหนึ่ง)
        อยากกินขนมปังสักชิ้น จึงเดินไปซื้อขนมปังที่ร้านสะดวกซื้อ
        (ซึ่งเป็นภาคธุรกิจ) ตอนที่เราซื้อขนมปัง เราจ่ายเงินให้ร้านค้า
        ขณะที่ร้านค้าก็เอาขนมปังมาแลกกับเงินของเรา ตรงนั้นคือ ‘ตลาดสินค้าและบริการ’
        <br></br><br></br>ตอนเย็นหลังเลิกเรียน
        เราก็กลับมารับจ้างเป็นพนักงานร้านสะดวกซื้อร้านเดิมที่เราไปซื้อขนมปังนั่นแหละ
        (ตอนนี้เราจะกลายเป็นแรงงาน ซึ่งเป็นส่วนหนึ่งของปัจจัยการผลิตแล้ว
        ให้พูดภาษาวิชาการของตรงนี้ก็คือเราบริการปัจจัยการผลิต) พอเราทำงานเสร็จ
        ร้านค้าก็จะให้เงินเรามา เรียกว่าค่าจ้าง
        หรือผลตอบแทนของปัจจัยการผลิตกลับมาที่เรา (หรือหน่วยครัวเรือน)
        <br></br><br></br>แล้วรัฐบาลล่ะ?
        <br></br><br></br> รัฐบาลสามารถแปลงร่างเป็นทุกอย่างได้หมดเลย
        ตั้งแต่เป็นเจ้าของปัจจัยการผลิต (
        เป็นเจ้าของโรงไฟฟ้าจ่ายไฟเข้าบ้านเราและโรงงาน)
        เป็นผู้บริโภคเหมือนหน่วยครัวเรือน (เช่น
        ซื้อคอมพิวเตอร์จากบริษัทคอมพิวเตอร์) และเป็นหน่วยธุรกิจ (เช่น
        ให้บริการซ่อมถนนให้กับเรา) ด้วยความที่รัฐบาลเป็นทุกอย่างให้เธอแล้ว
        ทำให้มีทรัพยากรเข้า-ออกรัฐบาลเต็มไปหมด ทรัพยากรพวกนั้นพวกนั้นแบ่งได้เป็นสองกลุ่ม
        
        <br></br><br></br>ทรัพยากรที่หน่วยครัวเรือนและรัฐบาลชี้เข้าไปที่รัฐบาลก็คือทุกคนจ่ายภาษีให้กับรัฐบาล
        ส่วนทรัพยกรที่ชี้ออกก็คือรัฐบาลเอาเงินที่เราจ่ายภาษีมาสร้างบริการอำนวยความสะดวกหรือแจกเงินให้กับทั้ง
        2 หน่วย แล้วรัฐบาลเอาพวกทรัพยากรที่ไหนมาอำนวยความสะดวกให้กับเรา? 
        <br></br><br></br>ตอบง่าย
        ๆ ก็คือรัฐบาลซื้อสินค้าและบริการจากหน่วยครัวเรือนและธุรกิจ
        เหมือนแค่เป็นตัวกลางเฉย ๆ เช่น รัฐบาลจะสร้างอาคารใหญ่แห่งหนึ่ง
        รัฐก็ใช้เงินภาษีของเราไปจ้างคนจากหน่วยครัวเรือนมาเป็นแรงงาน
        เราก็จะได้เงินคืนมา แล้วก็ซื้ออิฐ
        ซื้อปูนมาจากบริษัทรับเหมาก่อสร้างมาสร้างอาคาร
        หน่วยธุรกิจก็จะได้เงินจากรับบาลเหมือนกัน
        ทุกอย่างเป็นวงจรกันแบบนี้ไปเรื่อย ๆ
      </p>
      <h2>อ้างอิง</h2>
      <ul>
        <li>
          <a
            href="http://sagehouse.igetweb.com/articles/517671/%E0%B8%AB%E0%B8%99%E0%B9%88%E0%B8%A7%E0%B8%A2%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%A3%E0%B8%B5%E0%B8%A2%E0%B8%99%E0%B8%A3%E0%B8%B9%E0%B9%89%E0%B8%97%E0%B8%B5%E0%B9%881%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B9%8C%E0%B9%80%E0%B8%9A%E0%B8%B7%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B8%95%E0%B9%89%E0%B8%99.html
"
          >
            แหล่งอ้างอิงที่ 1
          </a>
        </li>
        <li>
          <a
            href="https://my.dek-d.com/anything-blabla/writer/viewlongc.php?id=731085&chapter=3"
          >
            แหล่งอ้างอิงที่ 2
          </a>
        </li>
        <li>
          <a
            href="https://social.mwit.ac.th/files/58_2_doc_s30105_2.pdf"
          >
            แหล่งอ้างอิงที่ 3
          </a>
        </li>
      </ul>
      <hr />
    </div>
  );
}
